import { MobileBanner } from './MobileBanner';
import { DesktopBanner } from './DesktopBanner';
import { FullWidthBanner } from './FullWidthBanner';

export const Banner = { MobileBanner, DesktopBanner, FullWidthBanner };
